module.exports = __webpack_public_path__ + "assets/img/icon3-menu.a9afc0dd.svg";